var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUploadPurple = function SvgUploadPurple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_2943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.25 17.2332C31.1167 11.4832 26.0667 7.1665 20 7.1665C15.1833 7.1665 11 9.89984 8.91667 13.8998C3.9 14.4332 0 18.6832 0 23.8332C0 29.3498 4.48333 33.8332 10 33.8332H31.6667C36.2667 33.8332 40 30.0998 40 25.4998C40 21.0998 36.5833 17.5332 32.25 17.2332ZM31.6667 30.4998H10C6.31667 30.4998 3.33333 27.5165 3.33333 23.8332C3.33333 20.4165 5.88333 17.5665 9.26667 17.2165L11.05 17.0332L11.8833 15.4498C13.4667 12.3998 16.5667 10.4998 20 10.4998C24.3667 10.4998 28.1333 13.5998 28.9833 17.8832L29.4833 20.3832L32.0333 20.5665C34.6333 20.7332 36.6667 22.9165 36.6667 25.4998C36.6667 28.2498 34.4167 30.4998 31.6667 30.4998ZM13.3333 22.1665H17.5833V27.1665H22.4167V22.1665H26.6667L20 15.4998L13.3333 22.1665Z",
    fill: "#A900E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_2943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadPurple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload_purple.bee7d0e0.svg";
export { ForwardRef as ReactComponent };